import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast"; // Assuming you want to use `toast` for error messages
import Cookies from "js-cookie";
import userService from "../Services/userService";
import { IoEyeOffOutline, IoEyeOutline } from "react-icons/io5";
import { DATA } from "../Utils/Constant";
import { usePermissions } from "../Utils/PermissionsContext";
import glock from "../Assets/glock.png";
import LightPillar from "../Components/LightPillar";
import glockLogo from "../Assets/Glock Auto Parts.png";

const Login = () => {
  const navigate = useNavigate();
  const { permissions, setPermissions } = usePermissions();

  const [data, setData] = useState({
    email: "",
    password: "",
  });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const [passwordVisible, setPasswordVisible] = useState(false);

  const togglePasswordVisibility = () => {
    setPasswordVisible(!passwordVisible);
  };

  const [regex] = useState({
    email: /.+@.+\..+/,
    password: /.{6,}/,
  });

  const handleChange = (value, field) => {
    setData((prevData) => ({ ...prevData, [field]: value }));
    setError("");
  };

  const handleSubmit = () => {
    setError("");
    let hasError = false;

    // Simple form validation
    if (!regex.email.test(data.email) || !regex.password.test(data.password)) {
      setError("Please enter valid credentials");
      toast.error("Invalid input");
      hasError = true;
    }

    if (!hasError) {
      setLoading(true);
      userService
        .login(data)
        .then((res) => {
          setPermissions(res.permissions);
          const userProfile = {
            id: res.user.id,
            email: res.user.email,
            role: res.user.role,
          };
          localStorage.setItem("user", JSON.stringify(userProfile));
          toast.success("Login Successfully");
          setLoading(false);

          Cookies.set(
            "XIOQUNVU1RPTUVSLUFVVEhFTlRJQ0FUSU9OIMSLQ1JFVC1LRVk=",
            res.token,
            {
              secure: false,
              sameSite: "Lax",
            },
          );

          navigate("/dashboard", { replace: true });
        })
        .catch((error) => {
          console.log(error);
          setLoading(false);
          if (error.responseCode === 400) {
            setError(error.message);
          } else if (error.responseCode === 403) {
            setError("Account Not Activated");
          } else {
            setError("Login failed. Please try again");
          }
        });
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      handleSubmit();
    }
  };
  return (
    <>
      <div style={{ width: "100%", height: "100vh", position: "relative" }}>
        <LightPillar
          topColor="#f1ff29"
          bottomColor="#e60000"
          intensity={1.1}
          rotationSpeed={1}
          glowAmount={0.001}
          pillarWidth={2}
          pillarHeight={0.4}
          noiseIntensity={1}
          pillarRotation={25}
          interactive={false}
          mixBlendMode="screen"
          quality="high"
        />

        <div className=" h-screen w-screen">
          <div className="h-screen w-screen flex flex-col gap-20 justify-center items-center">
            <img src={glockLogo} alt="" />
            <div
              className="w-[20%] xl:w-[30%] h-[90%] xl:h-[550px] flex justify-center drop-shadow-2xl rounded-[50px]
  bg-white/10 backdrop-blur-xl border border-white/30 shadow-[0_8px_32px_rgba(0,0,0,0.3)]"
            >
              <div className="w-full flex justify-center">
                <div className="flex flex-col w-full">
                  <h1 className="font-semibold text-4xl mt-20 text-center text-white tracking-wider">
                    Login
                  </h1>
                  <div className="mt-10 w-[100%] flex flex-col justify-center items-center space-y-6">
                    <div className="w-[60%]">
                      <label className="text-sm font-semibold text-white/80">
                        Email
                      </label>
                      <input
                        type="email"
                        value={data.email}
                        onChange={(e) => handleChange(e.target.value, "email")}
                        onKeyDown={handleKeyDown}
                        className="bg-white/10 backdrop-blur-sm text-white placeholder:text-white/50 w-full focus:outline-none px-4 py-2 rounded-md mt-1 border border-white/20 focus:border-white/60 transition-all duration-300"
                      />
                    </div>
                    <div className="w-[60%]">
                      <label className="text-sm font-semibold text-white/80">
                        Password
                      </label>
                      <div className="bg-white/10 backdrop-blur-sm w-full mt-1 px-4 py-2 rounded-md border border-white/20 focus-within:border-white/60 transition-all duration-300">
                        <div className="flex items-center justify-between">
                          <input
                            type={passwordVisible ? "text" : "password"}
                            value={data.password}
                            onChange={(e) =>
                              handleChange(e.target.value, "password")
                            }
                            onKeyDown={handleKeyDown}
                            className="w-full bg-transparent text-white focus:outline-none placeholder:text-white"
                          />
                          <button
                            onClick={togglePasswordVisibility}
                            className="focus:outline-none px-2"
                          >
                            {passwordVisible ? (
                              <IoEyeOutline className="text-gray-500" />
                            ) : (
                              <IoEyeOffOutline className="text-gray-500" />
                            )}
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="mt-10 w-full flex justify-center">
                      <button
                        onClick={handleSubmit}
                        disabled={loading}
                        className={`relative overflow-hidden bg-gradient-to-r font-medium bg-white text-black w-[60%] hover:shadow-2xl shadow-black mt-10 py-2 rounded-md
                                    ${loading ? "opacity-50 cursor-not-allowed" : ""}`}
                      >
                        Login
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;
